import React from 'react';
import './Navigation.scss';

const Navigation = () => {
    return (
        <nav className="navigation">
            <a className="logo" href="#!">
                XuanTruong
            </a>
        </nav>
    );
};

export default Navigation;
